import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [장비 모델 관리 > EOL/EOS 관리] 장비 모델 조회
   * @author Song
   * @return {[type]}   [description]
   */
  getDeviceModelList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-model-settings/get-device-model-list.do`, params);
  },
  /**
   * [장비 모델 관리 > EOL/EOS 관리] 장비 모델 추가
   * @author Song
   * @return {[type]}   [description]
   */
  insertDeviceModelList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-model-settings/insert-device-model-list.do`, params);
  },
  /**
   * [장비 모델 관리 > EOL/EOS 관리] 장비 모델 수정
   * @author Song
   * @return {[type]}   [description]
   */
  updateDeviceModelList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-model-settings/update-device-model-list.do`, params);
  },
  /**
   * [장비 모델 관리 > EOL/EOS 관리] 장비 모델 삭제
   * @author Song
   * @return {[type]}   [description]
   */
  deleteDeviceModelList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-model-settings/delete-device-model-list.do`, params);
  },
  /**
   * [장비 모델 관리 > EOL/EOS 관리] 장비 모델 리스트 엑셀 출력
   * @author Song
   * @return {[type]}   [description]
   */
  exportDeviceModelList() {
    window.location.assign(`${baseUrl}/settings/netdevice-model-settings/export-device-model-list.do`);
  },
  /**
   * [장비 모델 관리 > EOL/EOS 관리] 장비 모델 리스트 엑셀 템플릿 다운
   * @author Song
   * @return {[type]}   [description]
   */
  downloadDeviceModelTemplate() {
    window.location.assign(`${baseUrl}/settings/netdevice-model-settings/download-device-model-template.do`);
  },
  /**
   * [장비 모델 관리 > EOL/EOS 관리] 장비 모델 리스트 엑셀 입력
   * @author Song
   * @return {[type]}   [description]
   */
  importDeviceModelList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-model-settings/device-model-excel-import.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/netdevice/netdevice-life-cycle-settings.js